// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__h2w1B","cardWrapper":"styles_cardWrapper__HrH4x","cardHeading":"styles_cardHeading__TuFSa","buttonWrapper":"styles_buttonWrapper__Ltnrr"};